<div class="sign-up-container">
  <div class="container" [zeroLoadingIndicator]="ongoingRequest">
    <img alt="Logo" width="180" src="/assets/img/svgs/logo-redesign.svg" class="logo max-w-100" />
    <div class="zero-text p-huge-bold mb-3">{{ 'register.sign-up-resend.headline' | transloco }}</div>
    <div class="zero-text p-base-reg mb-4" [innerHTML]="'register.sign-up-resend.hint' | transloco"></div>
    <form (ngSubmit)="onSubmit()" #f="ngForm">
      <web-design-system-input
        [label]="'onboarding.sign-up.placeholder' | transloco"
        [value]="email$ | async"
        (valueChange)="handleEmailChange($event)"
        [isValid]="email$ | async | email"
        [error]="(email$ | async | email) === false ? ('register.sign-up-resend.error' | transloco) : null"
        class="d-block mb-5"
        data-zid="email"
      />
      <web-components-user-messages />
      <div class="d-flex justify-content-between align-items-center">
        <a routerLink=".." class="zero-text link" data-zid="signup-link">{{ 'register.sign-up-resend.link' | transloco }}</a>
        <web-design-system-button
          [isSubmit]="true"
          [fullwidth]="true"
          [disabled]="(isFormValid$ | async) === false"
          data-zid="sign-up-resend-btn"
        >
          {{ 'register.sign-up-resend.btn' | transloco }}
        </web-design-system-button>
      </div>
    </form>
  </div>
</div>
